<template>
  <EmailVerification />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import EmailVerification from "@/components/Account/email/EmailVerification.vue";

const componentName = "EmailVerificationRoute";

export default defineComponent({
  name: componentName,
  components: { EmailVerification },
});
</script>
